import React from 'react';
import { Container, Accordion } from '../design-system';
import { useI18n } from '../i18n/I18nProvider';

export function FAQ() {
  const { t } = useI18n();
  const faqs = [
    {
      id: '1',
      title: t('faq.items.1.title'),
      content: t('faq.items.1.content')
    },
    {
      id: '2',
      title: t('faq.items.2.title'),
      content: t('faq.items.2.content')
    },
    {
      id: '3',
      title: t('faq.items.3.title'),
      content: t('faq.items.3.content')
    },
    {
      id: '4',
      title: t('faq.items.4.title'),
      content: t('faq.items.4.content')
    },
    {
      id: '5',
      title: t('faq.items.5.title'),
      content: t('faq.items.5.content')
    },
    {
      id: '6',
      title: t('faq.items.6.title'),
      content: t('faq.items.6.content')
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <Container maxWidth="lg">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            {t('faq.heading')}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t('faq.description')}
          </p>
        </div>

        <Accordion items={faqs} />
      </Container>
    </section>
  );
}
